import { useState } from 'react'
import { useNavigate } from 'react-router-dom'

// Хук для обработки ошибок сервера
export function useHandleServerError<T extends string>() {
  const navigate = useNavigate()
  const [formErrors, setFormErrors] = useState<Record<T, string> | null>(null)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleServerError = (error: any) => {
    if (error && error.data && error.status) {
      const { data, status } = error

      // Логируем данные ошибки
      console.error('Response error:', { status, data })

      // Обработка ошибок формы (если статус 400 и есть поле errors)
      if (status === 400 && data) {
        console.error('Form errors:', data)

        // Преобразуем ошибки в объект { key: value }
        const formattedErrors = Object.entries(data).reduce(
          (acc, [key, values]) => {
            if (Array.isArray(values)) {
              acc[key as T] = values.join(', ') // Объединяем массив ошибок в строку
            } else {
              acc[key as T] = String(values) // Преобразуем одиночное значение в строку
            }
            return acc
          },
          {} as Record<T, string>,
        )

        setFormErrors(formattedErrors) // Устанавливаем ошибки формы
        return
      }

      // Обработка других статусов
      switch (status) {
        case 401:
          localStorage.clear()
          navigate('/login')
          console.error('Unauthorized: Проверьте токен авторизации.')
          break
        case 403:
          console.error('Forbidden: Доступ запрещён.')
          break
        case 404:
          console.error('Not Found: Проверьте URL или ресурс.')
          break
        case 500:
          console.error('Internal Server Error: Проблема на стороне сервера.')
          break
        default:
          console.error('Unhandled response status:', status)
      }
    } else if (error.request) {
      // Запрос был отправлен, но ответа нет
      console.error('No response from server:', error.request)
    } else {
      // Ошибка в процессе настройки запроса
      console.error('Unexpected error:', error.message)
    }

    setFormErrors(null) // Сбрасываем ошибки, если они не относятся к форме
  }

  return { formErrors, handleServerError }
}
